import { get } from 'lodash';
import { dateIsSameOrAfter } from 'util/formatters/dateFormatter';

export const getEnv = (state) => get(state, 'settings.env');
export const isAppMode = (state) => !!get(state, 'settings.isAppMode');
export const getAppVersion = (state) => get(state, 'settings.appVersion');
export const getRouteVersion = (state) => get(state, 'settings.routeVersion');

export const getDefaultScriptType = (state) => get(state, 'settings.defaultScriptType');
export const getReferrer = (state) => get(state, 'settings.referrer') || document.referrer;
export const cameFromSubfieldN = (state) => get(state, 'settings.cameFromSubfieldN', false);
export const getHasDoneFirstLoad = (state) => get(state, 'settings.hasDoneFirstLoad');

export const shouldShowWinfieldLink = (state) => get(state, 'settings.authClient') === 'winfield';

export const getEntryPath = (state) => get(state, 'settings.entryPath');
export const getProductYears = (state) => get(state, `settings.productYears`);
export const getProductYearByScriptType = (state, scriptType) => {
  return get(state, `settings.productYears.${scriptType}`);
};
export const isPastProductYearForScriptType = ({ productYear, scriptType, state }) => {
  return !dateIsSameOrAfter({ anchorDate: getProductYearByScriptType(state, scriptType), comparisonDate: productYear });
};

export const getDrive2Flag = (state) => get(state, 'launchDarkly.webDrive2Beta');